<style lang="scss" scoped>
    .mt100{
        margin-top: 100px;
    }
    .pt100{
        padding-top: 100px;
    }
    .contact{
        background-color: #fff;
    }

    ::v-deep.contact-page-test .sidebar-container{
        border-right: none!important;
    }
    ::v-deep.contact-page-test .sidebar-logo-container{
        border-right: solid 1px #ddd;
    }
    ::v-deep.contact-page-test .breadcrumb-container .el-breadcrumb__inner{
        pointer-events: none;
    }
</style>

<template>
    <Layout class="contact-page-test" >
        <div class="contact full-w full-h">
            <!--<p class="mt100 font14px text-bold tac">禁止访问，请联系聚投管理员~</p>-->
            <NoPermissionInfo class="pt100"/>
        </div>
    </Layout>
</template>

<script>

    import Layout from '@/layout/index.vue';
    import NoPermissionInfo from '@/components/noPermissionInfo';

    export default {
        name:'Contact',
        components:{
            Layout,
            NoPermissionInfo,
        },
        data() {
            return {}
        },
        created() {
            this.$store.dispatch('user/getUserInfo');
        },
        methods: {}
    }
</script>
